"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CssFonts = exports.CssBaseline = void 0;

var _utils = require("../../utils");

var _styledNormalize = require("styled-normalize");

var _const = require("../../const");

var _fonts = require("./fonts");

var _templateObject, _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CssBaseline = (0, _utils.createGlobalStyle)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  html {\n    height: 100%;\n    width: 100%;\n  }\n  body {\n    margin: 0;\n    height: 100%;\n    width: 100%;\n    font-family: ", ";\n    font-weight: 400;\n    line-height: 1.5;\n\n    #root,\n    .root {\n      height: 100%;\n      width: 100%;\n    }\n  }\n\n  *,\n  ::after,\n  ::before {\n    box-sizing: border-box;\n  }\n\n  b,\n  strong {\n    font-weight: 700;\n  }\n"])), _styledNormalize.normalize, _const.FontFamilyValue.primary);
exports.CssBaseline = CssBaseline;
CssBaseline.displayName = 'CssBaseline';
var CssFonts = (0, _utils.createGlobalStyle)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), _fonts.fonts);
exports.CssFonts = CssFonts;